import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"font-family":"monospace"} }
const _hoisted_2 = { class: "text-start" }
const _hoisted_3 = { class: "text-start" }
const _hoisted_4 = { class: "text-start" }
const _hoisted_5 = { class: "text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { title: "Foglalások" }, {
    text: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: $setup.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
                label: "Search",
                "prepend-inner-icon": "mdi-magnify",
                variant: "outlined",
                "hide-details": "",
                "single-line": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: $setup.statusFilter,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.statusFilter) = $event)),
                items: $setup.statusOptions,
                label: "Státusz",
                variant: "outlined",
                "hide-details": "",
                clearable: ""
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_data_table, {
        headers: $setup.headers,
        items: $setup.filteredItems,
        search: $setup.normalizedSearch
      }, {
        [`item.publicReference`]: _withCtx(({ item }) => [
          _createElementVNode("span", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString($setup.formatPublicReference(item.publicReference)), 1)
          ])
        ]),
        "item.startDate": _withCtx(({ value }) => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(value || '-'), 1)
        ]),
        "item.endDate": _withCtx(({ value }) => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(value || '-'), 1)
        ]),
        "item.status": _withCtx(({ value }) => [
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.bookingStatusLabel(value)), 1)
        ]),
        "item.id": _withCtx(({ item }) => [
          _createVNode(_component_v_chip, {
            color: "blue",
            text: "Részletek",
            onClick: () => $setup.handleViewClick(item.publicReference)
          }, null, 8, ["onClick"])
        ]),
        _: 2
      }, 1032, ["items", "search"])
    ]),
    _: 1
  }))
}